import { Button, Result } from "antd"
import { useAuth } from "react-oidc-context";

const NoCommunities: React.FC = () => {
    const auth = useAuth();
    const onLogOut = () => {
        const args = {
            extraQueryParams: {
                post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_URI as string
            }
        };
        void auth.signoutRedirect(args);
    }
    return (<Result status="403"
        title="There are no any available communities."
        extra={<Button onClick={onLogOut}>Log Out</Button>} />)
}

export default NoCommunities;